// components
import { ByTag } from 'components/v2/Filters/MultiSelect';

const filters = [ByTag];

export default filters;
